import * as React from 'react'

function SvgEmployee(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 30 30" fill="none" {...props}>
      <g clipPath="url(#employee_svg__clip0)" fill="currentColor">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M25 5H5v20h20V5zM5 2a3 3 0 00-3 3v20a3 3 0 003 3h20a3 3 0 003-3V5a3 3 0 00-3-3H5z"
        />
        <path d="M17 19a1 1 0 011-1h4a1 1 0 110 2h-4a1 1 0 01-1-1zM17 15a1 1 0 011-1h4a1 1 0 110 2h-4a1 1 0 01-1-1zM14 12a3 3 0 11-6 0 3 3 0 016 0zM16 20.151c0 .469-.342.849-.767.849H6.766C6.341 21 6 20.62 6 20.151v-.568c0-.185.036-.367.12-.527.36-.688 1.56-2.61 3.88-3.056v1.944l1 1.019 1-1.02V16c2.32.447 3.52 2.368 3.88 3.056.084.16.12.342.12.527v.568zM17 11a1 1 0 011-1h4a1 1 0 110 2h-4a1 1 0 01-1-1z" />
      </g>
      <defs>
        <clipPath id="employee_svg__clip0">
          <path fill="#fff" d="M0 0h30v30H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default SvgEmployee
